import React, { useContext } from "react";

import { observer } from "mobx-react";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { useRootAppStore } from "@hooks";

import { LiveEventSideMenuContext } from "@state/context/live/live-event-side-menu/LiveEventSideMenuContext";

export const RemoveEventButton = observer(function RemoveEventButton({
	store,
}: {
	store: EventViewStore;
}) {
	const liveEventMenuViewStore = useContext(LiveEventSideMenuContext);
	const rootStore = useRootAppStore();

	return (
		<button
			type="button"
			className="btn btn--square btn--square--xsml btn--primary--inverted"
			onClick={() => {
				liveEventMenuViewStore.removeEvent(store.eventId);
				rootStore.myBetsViewStore.cashoutStore.disposeSubscription(
					store.eventId
				);
			}}
		>
			<i className="u-icon u-icon--tny u-icon--close" />
		</button>
	);
});
